// For all <input> element types except checkbox, radio, and range (which have separate Bootstrap classes)
// To-Do: Create separate checkbox & radio components
import { joinClasses } from "@/utils/styling";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  type?: Exclude<React.HTMLInputTypeAttribute, "checkbox" | "radio" | "range">;
}

export default function TextInput({
  type = "text",
  className,
  onBlur,
  ...attributes
}: TextInputProps) {
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const trimmedValue = e.target.value.trim();
    if (!e.target.readOnly && e.target.value !== trimmedValue) {
      e.target.value = trimmedValue;
      const event = new Event("input", { bubbles: true });
      e.target.dispatchEvent(event);
    }
    onBlur?.(e);
  };

  return (
    <input
      {...attributes}
      type={type}
      className={joinClasses("form-control", className)}
      onBlur={handleBlur}
    />
  );
}
